<template>

  <svg
    t="1631091696948"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5244"
    width="64"
    height="64"
  ><path d="M512 64c247.424 0 448 200.576 448 448s-200.576 448-448 448S64 759.424 64 512 264.576 64 512 64z m0 64C299.936 128 128 299.936 128 512s171.936 384 384 384 384-171.936 384-384S724.064 128 512 128z m242.016 233.376a32 32 0 0 1 0 45.248l-271.52 271.52a32 32 0 0 1-45.248 0l-1.088-1.216a32.32 32.32 0 0 1-3.008-2.656l-135.776-135.776a32 32 0 1 1 45.248-45.248l117.12 117.12 249.024-248.992a32 32 0 0 1 45.248 0z" p-id="5245" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconComplete',
} as DefineComponent
</script>